module.exports = __webpack_public_path__ + "img/cocktail.33f6580e.svg";